/**
 * Compact inline diagram of the pyrolysis process:
 * biomass feedstock → pyrolysis reactor → biochar + bio-oil + syngas.
 * Uses site palette (char / paper / ember / moss). No external assets.
 */
export const PyrolysisDiagram = () => (
  <figure
    data-testid="pyrolysis-diagram"
    className="mt-6 border border-char-900/10 bg-paper p-6 md:p-8"
  >
    <div className="min-w-0 overflow-x-auto md:overflow-x-visible">
    <svg
      viewBox="0 0 720 240"
      role="img"
      aria-labelledby="pyrolysis-diagram-title pyrolysis-diagram-desc"
      className="h-auto"
      style={{ width: "720px", minWidth: "720px" }}
    >
      <title id="pyrolysis-diagram-title">The pyrolysis process</title>
      <desc id="pyrolysis-diagram-desc">
        Diagram of the pyrolysis process showing biomass feedstock converted into biochar,
        bio-oil, and syngas.
      </desc>

      {/* Feedstock */}
      <g>
        <rect rx="8" x="10" y="90" width="140" height="60" fill="#6E6E73" />
        <text x="80" y="118" textAnchor="middle" fontFamily="Aptos, sans-serif" fontWeight="600" fontSize="16" fill="#FAF9F7">
          Biomass
        </text>
        <text x="80" y="138" textAnchor="middle" fontFamily="Aptos, sans-serif" fontWeight="500" fontSize="14" fill="#FAF9F7">
          Feedstock
        </text>
      </g>

      {/* Arrow feedstock → reactor */}
      <g stroke="#0D0D0D" strokeWidth="1.5" fill="none">
        <line x1="152" y1="120" x2="238" y2="120" />
        <polyline points="230,114 240,120 230,126" />
      </g>

      {/* Reactor */}
      <g>
        <rect rx="8" x="240" y="70" width="180" height="100" fill="#0D0D0D" />
        <text x="330" y="112" textAnchor="middle" fontFamily="Aptos, sans-serif" fontWeight="700" fontSize="18" fill="#FAF9F7" letterSpacing="1">
          PYROLYSIS
        </text>
        <text x="330" y="132" textAnchor="middle" fontFamily="Aptos, sans-serif" fontWeight="500" fontSize="15" fill="#FAF9F7">
          Reactor
        </text>
        <text x="330" y="152" textAnchor="middle" fontFamily="Aptos, sans-serif" fontSize="12" fill="#A45A34" letterSpacing="1.2">
          HEAT · NO OXYGEN
        </text>
      </g>

      {/* Arrows reactor → 3 outputs */}
      <g stroke="#A45A34" strokeWidth="1.5" fill="none">
        {/* Biochar (top) */}
        <path d="M420 90 Q480 90 500 50" />
        <polyline points="495,42 501,50 493,55" />
        {/* Bio-Oil (middle) */}
        <line x1="422" y1="120" x2="498" y2="120" />
        <polyline points="490,114 500,120 490,126" />
        {/* Syngas (bottom) */}
        <path d="M420 150 Q480 150 500 190" />
        <polyline points="495,182 501,190 493,197" />
      </g>

      {/* Outputs */}
      <g fontFamily="Aptos, sans-serif" fontSize="16" fontWeight="600">
        {/* Biochar */}
        <rect rx="8" x="500" y="26" width="210" height="46" fill="#0D0D0D" />
        <text x="516" y="52" fill="#FAF9F7">Biochar</text>
        <text x="516" y="66" fontFamily="Aptos, sans-serif" fontSize="12" fill="#A45A34" letterSpacing="1">
          SOLID
        </text>
        {/* Bio-Oil */}
        <rect rx="8" x="500" y="96" width="210" height="46" fill="#0D0D0D" />
        <text x="516" y="122" fill="#FAF9F7">Bio-Oil</text>
        <text x="516" y="136" fontFamily="Aptos, sans-serif" fontSize="12" fill="#A45A34" letterSpacing="1">
          LIQUID
        </text>
        {/* Syngas */}
        <rect rx="8" x="500" y="166" width="210" height="46" fill="#0D0D0D" />
        <text x="516" y="192" fill="#FAF9F7">Syngas</text>
        <text x="516" y="206" fontFamily="Aptos, sans-serif" fontSize="12" fill="#A45A34" letterSpacing="1">
          GAS
        </text>
      </g>
    </svg>
    </div>
    <figcaption className="mono-label mt-4 text-char-700/60">
      Fig. 01 · The pyrolysis process, end-to-end
    </figcaption>
  </figure>
);

export default PyrolysisDiagram;
